/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementBase,
  AgreementBaseOptional,
  AgreementBaseMetaI,
  AgreementBaseTrackedI,
} from "./agreement-base";
import { AgreementBaseTracked, AgreementBaseMeta } from "./agreement-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementInstanceBase,
  AgreementInstanceBaseOptional,
  AgreementInstanceBaseMetaI,
  AgreementInstanceBaseTrackedI,
} from "./agreement-instance-base";
import {
  AgreementInstanceBaseTracked,
  AgreementInstanceBaseMeta,
} from "./agreement-instance-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementRef,
  AgreementRefOptional,
  AgreementRefMetaI,
  AgreementRefTrackedI,
} from "./agreement-ref";
import { AgreementRefTracked, AgreementRefMeta } from "./agreement-ref";

/**
 *
 * @export
 * @interface AgreementWithLatestInstanceDTO
 */
export interface AgreementWithLatestInstanceDTOOptional extends AgreementBaseOptional {
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementVersion?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementText?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementHeader?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementAgreeText?: string;
  /**
   *
   * @type {number}
   * @memberof AgreementWithLatestInstanceDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementName?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementWithLatestInstanceDTO
   */
  isGlobal?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementWithLatestInstanceDTO
   */
  sortOrder?: number;
}

export interface AgreementWithLatestInstanceDTO
  extends
    AgreementWithLatestInstanceDTOOptional,
    AgreementBase,
    AgreementInstanceBase,
    AgreementRef {
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementVersion?: number;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementText?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementHeader?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementAgreeText?: string;
  /**
   *
   * @type {number}
   * @memberof AgreementWithLatestInstanceDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementName?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgreementWithLatestInstanceDTO
   */
  isGlobal?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementWithLatestInstanceDTO
   */
  sortOrder?: number;
}

export interface AgreementWithLatestInstanceDTOTrackedI extends AgreementBaseOptional {
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementVersion?: number;
  agreementVersionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementText?: string;
  agreementTextIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementHeader?: string;
  agreementHeaderIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementAgreeText?: string;
  agreementAgreeTextIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementWithLatestInstanceDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AgreementWithLatestInstanceDTO
   */
  agreementName?: string;
  agreementNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementWithLatestInstanceDTO
   */
  isGlobal?: boolean;
  isGlobalIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementWithLatestInstanceDTO
   */
  sortOrder?: number;
  sortOrderIsSet: boolean;
}

transformDatesMap.set(
  "AgreementWithLatestInstanceDTO",
  function (model: AgreementWithLatestInstanceDTO) {
    if (typeof model.startActive == "string")
      model.startActive = new Date(model.startActive);
    if (typeof model.endActive == "string")
      model.endActive = new Date(model.endActive);
  },
);

export type AgreementWithLatestInstanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  agreementVersion: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  agreementText: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementHeader: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementAgreeText: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isGlobal: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  sortOrder: PropertyMeta<MetaTypeBase<number>>;
}>;

export var AgreementWithLatestInstanceDTOMeta: AgreementWithLatestInstanceDTOMetaI =
  {} as AgreementWithLatestInstanceDTOMetaI;
AgreementWithLatestInstanceDTOMeta = typeMeta(
  "AgreementWithLatestInstanceDTO",
  {
    startActive: propertyMeta(
      "startActive",
      false,
      false,
      false,
      MetaTypesBase.Date,
    ),
    endActive: propertyMeta(
      "endActive",
      false,
      false,
      false,
      MetaTypesBase.Date,
    ),
    agreementVersion: propertyMeta(
      "agreementVersion",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
    agreementText: propertyMeta(
      "agreementText",
      false,
      false,
      false,
      MetaTypesBase.string,
    ),
    agreementHeader: propertyMeta(
      "agreementHeader",
      false,
      false,
      false,
      MetaTypesBase.string,
    ),
    agreementAgreeText: propertyMeta(
      "agreementAgreeText",
      false,
      false,
      false,
      MetaTypesBase.string,
    ),
    assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
    tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
    agreementName: propertyMeta(
      "agreementName",
      false,
      false,
      false,
      MetaTypesBase.string,
    ),
    isGlobal: propertyMeta(
      "isGlobal",
      false,
      false,
      false,
      MetaTypesBase.boolean,
    ),
    sortOrder: propertyMeta(
      "sortOrder",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
  },
);

const metaI = AgreementWithLatestInstanceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([AgreementInstanceBaseMeta]);
  metaI.startActive.inheritedFrom = AgreementInstanceBaseMeta.startActive;
  metaI.endActive.inheritedFrom = AgreementInstanceBaseMeta.endActive;
  metaI.agreementVersion.inheritedFrom =
    AgreementInstanceBaseMeta.agreementVersion;
  metaI.agreementText.inheritedFrom = AgreementInstanceBaseMeta.agreementText;
  metaI.agreementHeader.inheritedFrom =
    AgreementInstanceBaseMeta.agreementHeader;
  metaI.agreementAgreeText.inheritedFrom =
    AgreementInstanceBaseMeta.agreementAgreeText;
  metaI.interfaces = metaI.interfaces.concat([AgreementRefMeta]);
  metaI.assignId.inheritedFrom = AgreementRefMeta.assignId;
  metaI.tempID.inheritedFrom = AgreementRefMeta.tempID;
  metaI.interfaces = metaI.interfaces.concat([AgreementBaseMeta]);
  metaI.agreementName.inheritedFrom = AgreementBaseMeta.agreementName;
  metaI.isGlobal.inheritedFrom = AgreementBaseMeta.isGlobal;
  metaI.sortOrder.inheritedFrom = AgreementBaseMeta.sortOrder;
});

export class AgreementWithLatestInstanceDTOTracked
  extends AgreementBaseTracked
  implements AgreementWithLatestInstanceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  agreementVersion__I?: number = undefined;
  agreementVersionIsSet: boolean = false;
  set agreementVersion(v: undefined | number) {
    if (v !== undefined) {
      this.agreementVersion__I = v;
      this.agreementVersionIsSet = true;
    } else {
      this.agreementVersion__I = v || undefined;
      this.agreementVersionIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementVersion() {
    return this.agreementVersion__I;
  }
  agreementText__I?: string = undefined;
  agreementTextIsSet: boolean = false;
  set agreementText(v: undefined | string) {
    if (v !== undefined) {
      this.agreementText__I = v;
      this.agreementTextIsSet = true;
    } else {
      this.agreementText__I = v || undefined;
      this.agreementTextIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementText() {
    return this.agreementText__I;
  }
  agreementHeader__I?: string = undefined;
  agreementHeaderIsSet: boolean = false;
  set agreementHeader(v: undefined | string) {
    if (v !== undefined) {
      this.agreementHeader__I = v;
      this.agreementHeaderIsSet = true;
    } else {
      this.agreementHeader__I = v || undefined;
      this.agreementHeaderIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementHeader() {
    return this.agreementHeader__I;
  }
  agreementAgreeText__I?: string = undefined;
  agreementAgreeTextIsSet: boolean = false;
  set agreementAgreeText(v: undefined | string) {
    if (v !== undefined) {
      this.agreementAgreeText__I = v;
      this.agreementAgreeTextIsSet = true;
    } else {
      this.agreementAgreeText__I = v || undefined;
      this.agreementAgreeTextIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementAgreeText() {
    return this.agreementAgreeText__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  agreementName__I?: string = undefined;
  agreementNameIsSet: boolean = false;
  set agreementName(v: undefined | string) {
    if (v !== undefined) {
      this.agreementName__I = v;
      this.agreementNameIsSet = true;
    } else {
      this.agreementName__I = v || undefined;
      this.agreementNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementName() {
    return this.agreementName__I;
  }
  isGlobal__I?: boolean = undefined;
  isGlobalIsSet: boolean = false;
  set isGlobal(v: undefined | boolean) {
    if (v !== undefined) {
      this.isGlobal__I = v;
      this.isGlobalIsSet = true;
    } else {
      this.isGlobal__I = v || undefined;
      this.isGlobalIsSet = false;
    }
    this.changeTracker = true;
  }
  get isGlobal() {
    return this.isGlobal__I;
  }
  sortOrder__I?: number = undefined;
  sortOrderIsSet: boolean = false;
  set sortOrder(v: undefined | number) {
    if (v !== undefined) {
      this.sortOrder__I = v;
      this.sortOrderIsSet = true;
    } else {
      this.sortOrder__I = v || undefined;
      this.sortOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get sortOrder() {
    return this.sortOrder__I;
  }
  constructor(
    config?: AgreementWithLatestInstanceDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: AgreementWithLatestInstanceDTOOptional,
    options?: AssignOptions,
  ): AgreementWithLatestInstanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.agreementVersion &&
      this.agreementVersionApplyFilter(optionsRequired.filter)
    ) {
      this.agreementVersion = config.agreementVersion;
      if (optionsRequired.unassign) this.agreementVersionIsSet = false;
      else this.agreementVersionIsSet = true;
    }
    if (
      config.agreementText &&
      this.agreementTextApplyFilter(optionsRequired.filter)
    ) {
      this.agreementText = config.agreementText;
      if (optionsRequired.unassign) this.agreementTextIsSet = false;
      else this.agreementTextIsSet = true;
    }
    if (
      config.agreementHeader &&
      this.agreementHeaderApplyFilter(optionsRequired.filter)
    ) {
      this.agreementHeader = config.agreementHeader;
      if (optionsRequired.unassign) this.agreementHeaderIsSet = false;
      else this.agreementHeaderIsSet = true;
    }
    if (
      config.agreementAgreeText &&
      this.agreementAgreeTextApplyFilter(optionsRequired.filter)
    ) {
      this.agreementAgreeText = config.agreementAgreeText;
      if (optionsRequired.unassign) this.agreementAgreeTextIsSet = false;
      else this.agreementAgreeTextIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.agreementName &&
      this.agreementNameApplyFilter(optionsRequired.filter)
    ) {
      this.agreementName = config.agreementName;
      if (optionsRequired.unassign) this.agreementNameIsSet = false;
      else this.agreementNameIsSet = true;
    }
    if (config.isGlobal && this.isGlobalApplyFilter(optionsRequired.filter)) {
      this.isGlobal = config.isGlobal;
      if (optionsRequired.unassign) this.isGlobalIsSet = false;
      else this.isGlobalIsSet = true;
    }
    if (config.sortOrder && this.sortOrderApplyFilter(optionsRequired.filter)) {
      this.sortOrder = config.sortOrder;
      if (optionsRequired.unassign) this.sortOrderIsSet = false;
      else this.sortOrderIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): AgreementWithLatestInstanceDTOTrackedI {
    const cloned = {} as AgreementWithLatestInstanceDTOTrackedI;
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.agreementVersionIsSetDeep() &&
      this.agreementVersionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementVersionIsSet = true;
      cloned.agreementVersion = this.agreementVersion;
    } else {
      //cloned.agreementVersionIsSet = false
    }
    if (
      this.agreementTextIsSetDeep() &&
      this.agreementTextApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementTextIsSet = true;
      cloned.agreementText = this.agreementText;
    } else {
      //cloned.agreementTextIsSet = false
    }
    if (
      this.agreementHeaderIsSetDeep() &&
      this.agreementHeaderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementHeaderIsSet = true;
      cloned.agreementHeader = this.agreementHeader;
    } else {
      //cloned.agreementHeaderIsSet = false
    }
    if (
      this.agreementAgreeTextIsSetDeep() &&
      this.agreementAgreeTextApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementAgreeTextIsSet = true;
      cloned.agreementAgreeText = this.agreementAgreeText;
    } else {
      //cloned.agreementAgreeTextIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.agreementNameIsSetDeep() &&
      this.agreementNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementNameIsSet = true;
      cloned.agreementName = this.agreementName;
    } else {
      //cloned.agreementNameIsSet = false
    }
    if (
      this.isGlobalIsSetDeep() &&
      this.isGlobalApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isGlobalIsSet = true;
      cloned.isGlobal = this.isGlobal;
    } else {
      //cloned.isGlobalIsSet = false
    }
    if (
      this.sortOrderIsSetDeep() &&
      this.sortOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sortOrderIsSet = true;
      cloned.sortOrder = this.sortOrder;
    } else {
      //cloned.sortOrderIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): AgreementWithLatestInstanceDTOTrackedI {
    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.agreementVersionApplyFilter(filter))
      this.agreementVersionIsSet = false;

    if (!this.agreementTextApplyFilter(filter)) this.agreementTextIsSet = false;

    if (!this.agreementHeaderApplyFilter(filter))
      this.agreementHeaderIsSet = false;

    if (!this.agreementAgreeTextApplyFilter(filter))
      this.agreementAgreeTextIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.agreementNameApplyFilter(filter)) this.agreementNameIsSet = false;

    if (!this.isGlobalApplyFilter(filter)) this.isGlobalIsSet = false;

    if (!this.sortOrderApplyFilter(filter)) this.sortOrderIsSet = false;

    return this;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.startActive,
      AgreementWithLatestInstanceDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.endActive,
      AgreementWithLatestInstanceDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  agreementVersionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.agreementVersion,
      AgreementWithLatestInstanceDTOMeta,
      this.agreementVersion,
      this,
    );
  }
  agreementVersionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementVersionIsSet && this.agreementVersionApplyFilter(filter))
      return true;

    return false;
  }
  agreementTextApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.agreementText,
      AgreementWithLatestInstanceDTOMeta,
      this.agreementText,
      this,
    );
  }
  agreementTextIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementTextIsSet && this.agreementTextApplyFilter(filter))
      return true;

    return false;
  }
  agreementHeaderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.agreementHeader,
      AgreementWithLatestInstanceDTOMeta,
      this.agreementHeader,
      this,
    );
  }
  agreementHeaderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementHeaderIsSet && this.agreementHeaderApplyFilter(filter))
      return true;

    return false;
  }
  agreementAgreeTextApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.agreementAgreeText,
      AgreementWithLatestInstanceDTOMeta,
      this.agreementAgreeText,
      this,
    );
  }
  agreementAgreeTextIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.agreementAgreeTextIsSet &&
      this.agreementAgreeTextApplyFilter(filter)
    )
      return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.assignId,
      AgreementWithLatestInstanceDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.tempID,
      AgreementWithLatestInstanceDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  agreementNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.agreementName,
      AgreementWithLatestInstanceDTOMeta,
      this.agreementName,
      this,
    );
  }
  agreementNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementNameIsSet && this.agreementNameApplyFilter(filter))
      return true;

    return false;
  }
  isGlobalApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.isGlobal,
      AgreementWithLatestInstanceDTOMeta,
      this.isGlobal,
      this,
    );
  }
  isGlobalIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isGlobalIsSet && this.isGlobalApplyFilter(filter)) return true;

    return false;
  }
  sortOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementWithLatestInstanceDTOMeta.sortOrder,
      AgreementWithLatestInstanceDTOMeta,
      this.sortOrder,
      this,
    );
  }
  sortOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sortOrderIsSet && this.sortOrderApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.agreementVersionIsSetDeep(filter)) return true;
    if (this.agreementTextIsSetDeep(filter)) return true;
    if (this.agreementHeaderIsSetDeep(filter)) return true;
    if (this.agreementAgreeTextIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.agreementNameIsSetDeep(filter)) return true;
    if (this.isGlobalIsSetDeep(filter)) return true;
    if (this.sortOrderIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
